import React from 'react';

/**
 * Presentational alert used to flag a non-blocking problem (e.g. the room layout
 * could not be loaded). Renders the `.warning-alert` markup and styles defined in
 * `app/styles/pages/component-warning-alert.scss`.
 */
export type WarningAlertProps = {
  title?: string;
  message?: string;
  icon?: string;
  modifier?: string;
};

const DEFAULT_ICON = 'images/warning-triangle.svg';

export function WarningAlert({ title, message, icon, modifier }: WarningAlertProps) {
  return (
    <div className={modifier ? 'warning-alert ' + modifier : 'warning-alert'}>
      <div className="warning-alert__icon">
        <img src={icon || DEFAULT_ICON} alt="" />
      </div>
      <div className="warning-alert__content">
        {title ? <p className="warning-alert__title">{title}</p> : null}
        {message ? <p className="warning-alert__message">{message}</p> : null}
      </div>
    </div>
  );
}
